'use strict'

module.exports = cmp

function cmp(a, b) {
    return a[0].mul(b[1]).cmp(b[0].mul(a[1]))
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/big-rat/cmp.js
// module id = eYil
// module chunks = 0